import { Injectable } from '@angular/core';
import { IFileSaveService } from '@infinitform/platform-core';

/** How long the object URL outlives the click, so the download can start reading it. */
const REVOKE_DELAY_MS = 10_000;

@Injectable()
export class FileSaveCloudService implements IFileSaveService {
  /** The browser gives no word on a cancelled download, so this always resolves true. */
  async saveFile(data: Blob, fileName: string): Promise<boolean> {
    const url = URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.rel = 'noopener';
    document.body.appendChild(link);
    try {
      link.click();
    } finally {
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS);
    }
    return true;
  }
}
